import { useState, useEffect, useCallback } from "react";
import { getCurrentProvider, type Provider } from "@/lib/provider";

export function useProvider() {
  const [provider, setProvider] = useState<Provider | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(() => {
    setLoading(true);
    setError("");
    getCurrentProvider()
      .then((p) => setProvider(p))
      .catch(() => setError("تعذر تحميل البيانات"))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { provider, loading, error, reload: load };
}